import { Image } from '@skytech/ui/Image'
import { useDispatch, connect } from 'react-redux'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import {
  decreaseStep,
  increaseStep,
  increaseStepBy,
  selectMachine,
  selectMachineImage,
} from '@/ducks/onboarding/onboardingActions'
import {
  getImages,
  getMachines,
  getOnboardingSelectedImageId,
  getOnboardingSelectedMachineId,
  getWorkType,
} from '@/ducks/onboarding/onboardingSelectors'
import { numberFormat } from '@/util/formatters/numbers'

import './step-machine.scss'

const StepMachine = ({ machines, selectMachine, workType }: any) => {
  const dispatch = useDispatch()

  const { whiteLabel } = useAppContext()

  return (
    <div id="step-machine" className="step">
      <h3 className={`work-type ${whiteLabel}`}>
        <Translation id={`${workType}/oppgaver`} />
      </h3>

      <h2 className="choose-model">
        <Translation id="Du kan velge mellom disse modellene" />
      </h2>
      {/* @ts-ignore */}
      <SelectProduct products={machines} selectAction={arg => selectMachine(arg)} />

      <div className="navigation">
        <button onClick={() => dispatch(decreaseStep())} className={whiteLabel}>
          <Translation id="Tilbake" />
        </button>
      </div>
    </div>
  )
}

const SelectProduct = ({ products, selectAction, isImage = false }: any) =>
  // @ts-ignore
  products.map(({ id, ...restOfProps }) => (
    // @ts-ignore
    <Product key={id} isImage={isImage} onClick={() => selectAction(id)} {...restOfProps} />
  ))

const Product = ({
  name,
  productName,
  description,
  usageDescription,
  specs,
  imgUrl,
  price,
  onClick,
  isImage,
  stock,
}: any) => {
  const { whiteLabel } = useAppContext()

  return (
    <div className="product">
      <div className="product__image">{imgUrl && <Image src={imgUrl} alt="product" />}</div>

      <div className="product__description">
        <h2>{name}</h2>

        {!isImage && <h3>{productName}</h3>}

        <h4>{specs}</h4>
        <p>{description}</p>
        <p>{usageDescription}</p>

        {!isImage && (
          <h4>
            <Translation id="Lager: {stock}" stock={<b>{stock}</b>} />
          </h4>
        )}

        {!isImage && (
          <h4>
            <Translation id="Pris: {price}" values={{ price: <b>{numberFormat(price)},-</b> }} />
          </h4>
        )}

        <button onClick={onClick} className={whiteLabel}>
          <Translation id="Velg denne" />
        </button>
      </div>
    </div>
  )
}
// @ts-ignore
const mapStateToProps = state => ({
  selectedMachineId: getOnboardingSelectedMachineId(state),
  selectedImageId: getOnboardingSelectedImageId(state),
  machines: getMachines(state),
  images: getImages(state),
  workType: getWorkType(state),
})

const mapDispatchToProps = {
  selectMachine,
  selectMachineImage,
  increaseStep,
  increaseStepBy,
}

export default connect(mapStateToProps, mapDispatchToProps)(StepMachine)
